import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Quill from 'quill';
//  Import Quill's snow theme CSS
import 'quill/dist/quill.snow.css';
import '../../ConfigFiles/rounded_quill.css';

const DentistryTextEditor = forwardRef(({ placeholder, onTextChange }, ref) => {
  //  To store Quill instance
  const quillRef = useRef(null);
  //  To store the editor DOM element
  const editorRef = useRef(null);

  useEffect(() => {
    if (!editorRef.current) return;

    //  Initialize Quill
    const quillInstance = new Quill(editorRef.current, {
      theme: 'snow',
      placeholder: placeholder || 'Start typing...',
      modules: {
        toolbar: false, // No toolbar
      },
    });

    quillRef.current = quillInstance;

    //  Handle text changes
    const handleTextChange = () => {
      const content = quillInstance.getText();
      if (onTextChange) {
        onTextChange(content.trim());
      }
    };

    //  Add text-change event listener
    quillInstance.on('text-change', handleTextChange);

    //  Clean up on unmount
    return () => {
      quillInstance.off('text-change', handleTextChange);
    };
  }, [placeholder, onTextChange]);

  // Expose a clearEditor function to the parent
  useImperativeHandle(ref, () => ({
    clearEditor: () => {
      if (quillRef.current) {
        quillRef.current.setText('');
      }
    },
  }));

  return (
    <div
      ref={editorRef}
      className="quill-editor"
      style={{ height: '300px' }}
    />
  );
});

export default React.memo(DentistryTextEditor);
